let delay = false;
const iconArrow = document.querySelector(
  ".sticky_message_wrapper .message_open_close",
);
const background = document.querySelector(".sticky_message_background");
const mobileOpen = document.querySelector(".mobile_open");
const stickyMessage = document.querySelector(".sticky_message_wrapper");

if (window.matchMedia("(hover: hover)").matches) {
  stickyMessage.addEventListener("mouseover", () => {
    if (!stickyMessage.classList.contains("open") && !delay) {
      open();
    }
  });
  stickyMessage.addEventListener("mouseleave", () => {
    close();
    startDelay();
  });
}

iconArrow.addEventListener("click", () => {
  if (!stickyMessage.classList.contains("open")) {
    open();
  } else {
    close();
    startDelay();
  }
});

background.addEventListener("click", close);

mobileOpen.addEventListener("click", () => {
  if (!stickyMessage.classList.contains("open") && !delay) {
    open();
  } else if (stickyMessage.classList.contains("open")) {
    close();
    startDelay();
  }
});

const closeIcon = document.querySelector(".sticky_message_wrapper .close-icon");
if (closeIcon) {
  closeIcon.addEventListener("click", () => {
    stickyMessage.style.display = "none";
  });
}

document.addEventListener("DOMContentLoaded", () => {
  if (window.location.pathname == "/") {
    open();
    let isMouseHover = false;
    const messageContent = document.querySelector(
      ".sticky_message_wrapper .message_content",
    );
    messageContent.addEventListener("click", () => {
      isMouseHover = true;
    });
    setTimeout(() => {
      if (!isMouseHover) {
        close();
        startDelay();
      }
    }, 3000);
  }
});

function open() {
  stickyMessage.classList.add("open");
}

function close() {
  stickyMessage.classList.remove("open");
}

function startDelay() {
  delay = true;
  setTimeout(() => {
    delay = false;
  }, 300);
}
